import React, { Suspense } from 'react';
import { StyledAccountCredentialsButton } from '@hub/features/account-dashboard/components/styled-account-credentials-button/styled-account-credentials-button';
import type { TagData } from '@hub/features/account-dashboard/types/tag-data.types';
import { Box } from '@mui/material';
import { Account, Program } from '@monorepo/types';
import { ClickableTitle } from '../../clickable-title';
import { MobileContainer, MobileTagsContainer } from '../styled';
import { getProgramDisplayText, renderStatusTag, renderTag } from '../utils';

interface MobileHeaderViewProps {
  tagData: TagData;
  program: Program | undefined | null;
  account: Account | null | undefined;
  isMenuOpen: boolean;
  mobileAnchorRef: React.RefObject<HTMLDivElement | null>;
  onMenuToggle: () => void;
}

export const MobileHeaderView: React.FC<MobileHeaderViewProps> = ({
  tagData,
  program,
  account,
  isMenuOpen,
  mobileAnchorRef,
  onMenuToggle,
}) => {
  return (
    <MobileContainer>
      <MobileTagsContainer>
        <Box sx={{ display: 'flex', gap: 'inherit' }}>
          {renderTag(
            tagData.tradingInstrument.label,
            tagData.tradingInstrument.color,
          )}
          {renderStatusTag(tagData)}
          {renderTag(tagData.accountType.label, tagData.accountType.color)}
        </Box>
        {account && (
          <Suspense fallback={null}>
            <StyledAccountCredentialsButton
              account={{
                tsAccount: account?.tsAccount || '',
                tradingSystem: account?.tradingSystem || '',
                tsUserId: account?.tsUserId || '',
                tsAccountId: account?.tsAccountId || '',
              }}
              useNovaModal={true}
            />
          </Suspense>
        )}
      </MobileTagsContainer>

      <ClickableTitle
        ref={mobileAnchorRef}
        title={getProgramDisplayText(program?.name)}
        isOpen={isMenuOpen}
        onClick={onMenuToggle}
      />
    </MobileContainer>
  );
};
